/**
 * Page — the content wrapper every route renders. Sets document.title (= the
 * menu label, single nav source), renders the page title + optional actions
 * row (the ONE CTA per page lives in `actions`), then children.
 *
 * The shell chrome (sidebar / breadcrumb / global search) is provided by
 * <AppShell>; Page owns only the in-content title block.
 */
import { useEffect, type ReactNode } from 'react';

export function Page({
  title,
  subtitle,
  actions,
  children,
}: {
  title: string;
  subtitle?: string;
  /** Right-aligned action area — keep to a single primary CTA per page. */
  actions?: ReactNode;
  children: ReactNode;
}) {
  useEffect(() => {
    document.title = `${title} · Eval Pilot`;
  }, [title]);

  return (
    <div className="space-y-4">
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <h1 className="text-xl font-semibold truncate">{title}</h1>
          {subtitle && <p className="text-sm text-gray-500 mt-0.5">{subtitle}</p>}
        </div>
        {actions && <div className="flex items-center gap-2 shrink-0">{actions}</div>}
      </div>
      {children}
    </div>
  );
}
